import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';


const SignIn = () => {
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { data, error: signInError } = await signIn(formData?.email, formData?.password);
      
      if (signInError) {
        setError(signInError?.message || 'Invalid email or password');
        setLoading(false);
        return;
      }

      if (data?.user) {
        navigate('/client-portal');
      }
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="min-h-screen bg-background pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-8 md:py-12 lg:py-16">
          <div className="max-w-md mx-auto">
            <div className="bg-card rounded-lg border border-border p-6 md:p-8 shadow-lg">
              <div className="text-center mb-6 md:mb-8">
                <div className="w-16 h-16 md:w-20 md:h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name="Lock" size={32} color="var(--color-primary)" className="md:w-10 md:h-10" />
                </div>
                <h1 className="text-2xl md:text-3xl font-bold text-foreground mb-2 font-headline">Sign In</h1>
                <p className="text-sm md:text-base text-muted-foreground">
                  Access your secure client portal
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
                <Input
                  type="email"
                  label="Email Address"
                  placeholder="Enter your email"
                  value={formData?.email}
                  onChange={(e) => setFormData({ ...formData, email: e?.target?.value })}
                  required
                />

                <Input
                  type="password"
                  label="Password"
                  placeholder="Enter your password"
                  value={formData?.password}
                  onChange={(e) => setFormData({ ...formData, password: e?.target?.value })}
                  required
                />

                {error && (
                  <div className="bg-error/10 border border-error/20 rounded-lg p-3 flex items-start gap-2">
                    <Icon name="AlertCircle" size={18} color="var(--color-error)" className="flex-shrink-0 mt-0.5" />
                    <p className="text-sm text-error">{error}</p>
                  </div>
                )}

                <Button
                  type="submit"
                  className="w-full"
                  disabled={loading}
                >
                  {loading ? 'Signing in...' : 'Sign In'}
                </Button>
              </form>

              <div className="mt-6 text-center">
                <p className="text-sm text-muted-foreground">
                  Don't have an account?{' '}
                  <Link to="/sign-up" className="text-primary hover:underline font-medium">
                    Sign Up
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignIn;